@if (selectedEspace$ | async; as espace) {
<mat-card
    data-tfa="espace-actuel-card"
    id="espace-actuel-card"
    matTooltip="Les codes et le libelle indiquent ici l'espace de travail sélectionné et l'objet le plus haut de la branche/maquette"
>
    <mat-card-content>
        {{ espace.code }} - {{ espace.libelle }}
        <app-espace-chip [espace]="espace"></app-espace-chip>
        @if (racine$ | async; as racine) {
        <div>{{ racine.code }}</div>
        }
    </mat-card-content>
</mat-card>
}
